<template>
  <div class="home main-content">
    <MainHeader :navName="'拍卖'"></MainHeader>
    <div class="content">
      <div class="btns">
        <Button class="btns-item"  icon="ios-print" type="primary" @click="onPrint">打印</Button>
        <Button class="btns-item"  icon="md-mail" type="primary" :loading="options.sendMailLoading" @click="onSendMail">
          <span v-if="!options.sendMailLoading">发送邮箱</span>
          <span v-else>发送中</span>
        </Button>
        <Button class="btns-item"  icon="md-time" type="warning" @click="modals.scheduleMode = true">时间表</Button>
      </div>
      <div class="tip">
        <div class="tip-title">
          {{database.info.title}}
        </div>
        <div class="tip-time" v-if="curProgress <= 1">
          投标结束
          <div class="tip-time-num">{{database.info.place_order_end_time | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div class="tip-time" v-if="curProgress > 1">
          开盘结果
          <div class="tip-time-num">{{database.info.early_morning | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div class="tip-time">
          当前系统时间
          <div class="tip-time-num">{{curSysTime | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
      </div>
      <div class="btn2s" v-if="database.info.join != 1">
        <div class="btn2s-item">
          <div v-if="curProgress === 1">
            <img v-if="database.info.join == 1" class="icon-right" src="../assets/images/icon-right.png">竞标
          </div>
          <div v-if="curProgress === 2">
            <img v-if="database.info.join == 1" class="icon-right" src="../assets/images/icon-right.png">等待结果
          </div>
          <div v-if="curProgress === 3">
            <Icon type="md-checkmark" size="20" style="font-weight: bold; color: #19be6b; margin-right: 5px;" />结果
          </div>
        </div>
        <div class="btn2s-item">剩余时间: <span style="font-weight: bold">{{timeLeft.d}}:{{timeLeft.h}}:{{timeLeft.m}}:{{timeLeft.s}}</span></div>
        <div class="btn2s-item" v-if="database.info.join == 0"><Icon class="text-error" size="18" style="font-weight: bold" type="md-close" />未注册</div>
        <div class="btn2s-item" v-if="database.info.join == 1">
          <span v-if="selectList.num > 0"><Icon size="20" class="text-success" style="font-weight: bold; margin-right: 10px" type="md-checkmark" />已竞标：{{selectList.num}}</span>
          <span v-else>未竞标</span>
        </div>
        <div class="btn2s-item" v-if="database.info.join == 1">总价格：${{selectList.total}}</div>
      </div>
      <div class="btn2s" v-else-if="curProgress !== 3">
        <div class="btn2s-item">
          <div v-if="curProgress === 1">
            <img v-if="database.info.join == 1" class="icon-right" src="../assets/images/icon-right.png">竞标
          </div>
          <div v-if="curProgress === 2">
            <img v-if="database.info.join == 1" class="icon-right" src="../assets/images/icon-right.png">等待结果
          </div>
        </div>
        <div class="btn2s-item">剩余时间: <span style="font-weight: bold">{{timeLeft.d}}:{{timeLeft.h}}:{{timeLeft.m}}:{{timeLeft.s}}</span></div>
        <div class="btn2s-item" v-if="database.info.join == 0"><Icon class="text-error" size="18" style="font-weight: bold" type="md-close" />未注册</div>
        <div class="btn2s-item" v-if="database.info.join == 1">
          <span v-if="selectList.num > 0"><Icon size="20" class="text-success" style="font-weight: bold; margin-right: 10px" type="md-checkmark" />已竞标：{{selectList.num}}</span>
          <span v-else>未竞标</span>
        </div>
        <div class="btn2s-item" v-if="database.info.join == 1">总价格：${{selectList.total}}</div>
      </div>
      <div class="btn2s" v-else>
        <div class="btn2s-item">
          <div v-if="curProgress === 3">
            <Icon type="md-checkmark" size="20" style="font-weight: bold; color: #19be6b; margin-right: 5px;" />结果
          </div>
        </div>
        <div class="btn2s-item" >
          <span>中标数量：{{donList.num}}</span>
        </div>
        <div class="btn2s-item" >
          <span>中标重量：{{donList.weight}}Ct</span>
        </div>
        <div class="btn2s-item" >
          <span>中标价格：${{donList.prize}}</span>
        </div>
      </div>
      <div class="registration" v-if="database.info.join == 0">
        <div class="registration-title">登记处</div>
        <div class="registration-content">要参加拍卖，你必须注册并接受规则。</div>
        <div class="registration-btn"><Button class="registration-btn-item" type="success" @click="modals.registrationModal = true">登记</Button></div>
      </div>
      <div class="screen">
        <div class="screen-box">
          <div class="screen-value">全部</div>
          <Dropdown placement="bottom-start">
            <a href="javascript:void(0)">
              <div class="screen-icon"><Icon type="ios-funnel" /><Icon class="dropdown"  size="14" type="md-arrow-dropdown" /></div>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>全部</DropdownItem>
              <DropdownItem v-for="(item, index) in screenList" :key="index">{{item}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
<!--      <div class="tab">-->
<!--        <div class="tab-item tab-item-type1" @click="switchType(1)" :class="options.type == 1?'active': ''">列表</div>-->
<!--        <div class="tab-item tab-item-type2" @click="switchType(2)" :class="options.type == 2?'active': ''">我的购物车</div>-->
<!--        <div class="tab-item tab-item-type3" @click="switchType(3)" :class="options.type == 3?'active': ''">我的订单</div>-->
<!--      </div>-->
<!--      <div class="tab-bottom" :style="tabBottomStyle">-->
<!--        <div class="tab-total" v-if="options.type == 2">共计：<span style="font-weight: bold">999</span>Ct</div>-->
<!--      </div>-->
      <div class="table">
        <!-- 整包 -->
        <section v-if="database.info.types == 0">
          <section v-if="database.info.join == 1 && curProgress !== 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th>批数 <br>N</th>
                <th></th>
                <th width="65">查看</th>
                <th>类型</th>
                <th>数量 <br>q-ty</th>
                <th>重量 <br>Ct</th>
                <th>起拍价</th>
                <th>出价 <br>$</th>
                <th></th>
                <th>拍卖价格 <br>$/Ct</th>
                <th width="120">拍卖状态 </th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td><Icon style="color: #7b6d5b; cursor: pointer;" size="20" type="md-cube" @click="onGoDetail(item, index)" /></td>
                <td>
                  <div style="display: flex;">
                    <div class="icon-search" style="color: #fff; cursor: pointer" @click="onShowViewModal('request', index)"><Icon type="ios-search"  size="28" /></div>
                    <!--                  <Icon size="20" style="font-weight: bold; margin-left: 5px; margin-top: 3px" class="text-success" type="md-checkmark" />-->
                  </div>
                </td>
                <td>{{item.form}}</td>
                <td>{{item.number}}</td>
                <td>{{item.standard_box_weight}}</td>
                <td>{{item.bid_price}}</td>
                <td style="width: 80px" :style="item.auction != 0? 'background: #edfff3;': ''">
                  <Input v-if="curProgress === 1 && item.auction == 0" :min="0" v-model="item.bid_value"></Input>
                  <span v-if="item.auction != 0">{{item.bid_value || '---'}}</span>
                </td>
                <td>
                  <div v-if="curProgress === 1">
                    <Button v-if="item.auction == 0"  type="success" @click="onAuction(index, 1)">竞标</Button>
                    <span v-if="item.auction  == 1" class="text-primary" style="cursor: pointer" @click="onAuction(index, -1)">取消竞标</span>
                  </div>
                </td>
                <td>
                  <span v-if="item.auction != 0 && item.bid_value">{{(item.bid_value / item.standard_box_weight).toFixed(2)}}</span>
                  <span v-else>-</span>
                </td>
                <td style="position: relative">
                  <span v-if="item.auction == 0 && !item.bid_value">未竞标</span>
                  <span v-else-if="item.auction == 0 && (item.bid_value % 1) !== 0"  class="text-error">竞标必须是整数</span>
                  <span v-else-if="item.auction == 0 && item.bid_value < parseInt(item.bid_price)" class="text-error">小于起拍价</span>
                  <span v-else-if="item.auction == 0 && item.bid_value" class="text-warning">
                    <Icon type="ios-clipboard" size="20" style="position: absolute; left: 20px" />未保存</span>
                  <span v-else-if="item.auction == 1" class="text-success">已竞标</span>
                  <span v-else class="text-success">已确认</span>
                </td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
          <section v-if="database.info.join == 0 && curProgress !== 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th>批数 <br>N</th>
                <th></th>
                <th>类型</th>
                <th>数量 <br>q-ty</th>
                <th>重量 <br>Ct</th>
                <th>价格 <br>$/Ct</th>
                <th>起拍价</th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td><Icon style="color: #7b6d5b; cursor: pointer;" size="18" type="md-cube" @click="onGoDetail(item, index)" /></td>
                <td>{{item.form}}</td>
                <td>{{item.number}}</td>
                <td>{{item.standard_box_weight}}</td>
                <td>{{(item.bid_price / item.standard_box_weight).toFixed(2)}}</td>
                <td>{{item.bid_price}}</td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
          <section v-if="curProgress == 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th width="80">批数 <br>N</th>
                <th>类型</th>
                <th  width="100">重量 <br>Ct</th>
                <th  width="100">起标价 <br>$/Ct</th>
                <th  width="100">中标价 <br>$/Ct</th>
                <th  width="100">中标价 <br>$</th>
                <th  width="100">我的出价 <br>$</th>
                <th  width="100">状态</th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td>{{item.form}}</td>
                <td>{{item.standard_box_weight || '-'}}</td>
                <td>{{(item.bid_price / item.standard_box_weight).toFixed(2) || '-'}}</td>
                <td>
                  <span v-if="item.won_price">
                    {{(item.won_price / item.standard_box_weight).toFixed(2)}}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>{{item.won_price || '-'}}</td>
                <td>{{item.my_bid_value || '-'}}</td>
                <td>
                  <span v-if="item.my_bid_value == item.won_price"><Icon type="md-checkmark" size="20" style="font-weight: bold; color: #19be6b; margin-right: 5px;" />中标</span>
                  <span v-else-if="item.won_price">已售</span>
                  <span v-else-if="!item.won_price">未售</span>
                </td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
        </section>
        <!-- 单颗 -->
        <section v-if="database.info.types == 1">
          <section v-if="database.info.join == 1 && curProgress !== 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th>批数 <br>N</th>
                <th width="65">下载</th>
                <th>类型</th>
                <th>数量 <br>q-ty</th>
                <th>重量 <br>Ct</th>
                <th>起拍价 <br>$</th>
                <th>出价 <br>$</th>
                <th></th>
                <th>拍卖价格 <br>$/Ct</th>
                <th width="120">拍卖状态 </th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td>
                  <div class="icon-zip-box" @click="onShowViewModal('download', index)">
                    <img src="../assets/images/icon-zip.png">
                  </div>
                </td>
                <td>{{item.form}}</td>
                <td>{{item.number}}</td>
                <td>{{item.d_size}}</td>
                <td>{{item.start_value}}</td>
                <td style="width: 80px" :style="item.auction != 0? 'background: #edfff3;': ''">
                  <Input v-if="curProgress === 1 && item.auction == 0" :min="0" v-model="item.bid_value"></Input>
                  <span v-if="item.auction != 0">{{item.bid_value || '---'}}</span>
                </td>
                <td>
                  <div v-if="curProgress === 1">
                    <Button v-if="item.auction == 0"  type="success" @click="onAuction(index, 1)">竞标</Button>
                    <span v-if="item.auction  == 1" class="text-primary" style="cursor: pointer" @click="onAuction(index, -1)">取消竞标</span>
                  </div>
                <td>
                  <span v-if="item.auction != 0 && item.bid_value">{{(item.bid_value / item.d_size).toFixed(2)}}</span>
                  <span v-else>-</span>
                </td>
                <td style="position: relative">
                  <span v-if="item.auction == 0 && !item.bid_value">未竞标</span>
                  <span v-else-if="item.auction == 0 && (item.bid_value % 1) !== 0"  class="text-error">竞标必须是整数</span>
                  <span v-else-if="item.auction == 0 && item.bid_value < parseInt(item.bid_price)" class="text-error">小于起拍价</span>
                  <span v-else-if="item.auction == 0 && item.bid_value" class="text-warning">
                    <Icon type="ios-clipboard" size="20" style="position: absolute; left: 20px" />未保存</span>
                  <span v-else-if="item.auction == 1" class="text-success">已竞标</span>
                  <span v-else class="text-success">已确认</span>
                </td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
          <section v-if="database.info.join == 0 && curProgress !== 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th>批数 <br>N</th>
                <th>下载</th>
                <th>类型</th>
                <th>数量 <br>q-ty</th>
                <th>重量 <br>Ct</th>
                <th>价格 <br>$/Ct</th>
                <th>起拍价</th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td>
                  <div class="icon-zip-box" @click="onShowViewModal('download', index)">
                    <img src="../assets/images/icon-zip.png">
                  </div>
                </td>
                <td>{{item.form}}</td>
                <td>{{item.number}}</td>
                <td>{{item.d_size}}</td>
                <td>{{(item.start_value / item.d_size).toFixed(2)}}</td>
                <td>{{item.start_value}}</td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
          <section v-if="curProgress == 3">
            <table  style="width: 100%;">
              <tr class="tab-title">
                <th width="80">批数 <br>N</th>
                <th>类型</th>
                <th width="100">重量 <br>Ct</th>
                <th width="100">起标价 <br>$/Ct</th>
                <th width="100">中标价 <br>$/Ct</th>
                <th width="100">中标价 <br>$</th>
                <th width="100">我的出价 <br>$</th>
                <th width="100">状态</th>
              </tr>
              <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
                <td>{{index + 1}}</td>
                <td>{{item.form}}</td>
                <td>{{item.d_size || '-'}}</td>
                <td>{{(item.start_value / item.d_size).toFixed(2) || '-'}}</td>
                <td>
                  <span v-if="item.won_price">
                    {{(item.won_price / item.d_size).toFixed(2) || '-'}}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>{{item.won_price || '-'}}</td>
                <td>{{item.my_bid_value || '-'}}</td>
                <td>
                  <span v-if="item.my_bid_value == item.won_price"><Icon type="md-checkmark" size="20" style="font-weight: bold; color: #19be6b; margin-right: 5px;" />中标</span>
                  <span v-else-if="item.won_price">已售</span>
                  <span v-else-if="!item.won_price">未售</span>
                </td>
              </tr>
              <tr v-if="!database.list || database.list.length <= 0">
                <td  colspan="11">暂无数据~</td>
              </tr>
            </table>
          </section>
        </section>
      </div>
          <MainFooter></MainFooter>
    </div>
    <Modal v-model="modals.registrationModal" class-name="vertical-center-modal" @on-ok="onRegistration">
      <p>确认我愿意参加由上市股份公司雅罗莎举办的这次拍卖会?</p>
    </Modal>
    <Modal v-model="modals.scheduleMode" width="300"
           class-name="schedule-modal"
           footer-hide>
      <p slot="header" style="color:#fff;text-align:center; font-weight: bold;">
        <span>时间表</span>
      </p>
      <div style="text-align:center">
        <div class="schedule-item">
          <div class="schedule-item-name">登记时间</div>
          <div class="schedule-item-value">{{database.info.join_time | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="database.info.join == 1">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
        <div class="schedule-item" :class="curProgress == 1? 'cur': ''">
          <div class="schedule-item-name">投标时间</div>
          <div class="schedule-item-value">{{database.info.place_order_start_time | unixToDate('MM月DD日 HH:mm')}} - {{database.info.place_order_end_time | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="curProgress > 1">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
        <div class="schedule-item">
          <div class="schedule-item-name">开盘结果</div>
          <div class="schedule-item-value">{{database.info.early_morning | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="curProgress == 3">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-model="modals.viewMode" class-name="vertical-center-modal">
      <p style="font-size: 16px">你要看<span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批</span>石头吗？</p>
    </Modal>
    <Modal v-model="modals.downloadScanMode" class-name="vertical-center-modal">
      <p style="text-align: center; margin-top: 10px">确定下载 <span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批石头</span>的数码扫描？</p>
      <div style="text-align: center;margin-top: 20px">
        <Button style="margin: 0 10px" @click="modals.downloadScanMode = false">取消</Button>
        <Button style="margin: 0 10px" type="success" icon="md-cloud-download" @click="onDown">下载</Button>
      </div>
      <div slot="footer">
        <p style="text-align: center">*请注意,此处提供的 Sarine galax扫描和Zvi yehuda测色仪是由 Sarine技术有限公司在其在莫斯科的认可实验室中创建的。</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import MainHeader from '../public/MainHeader'
import MainFooter from '../public/MainFooter'
import Core from '@/until/core'
import moment from 'moment'

const postDownLoadFile = function (options) { // 下载Excel
  /* eslint-disable */
  const config = $.extend(true, { method: 'post' }, options)
  const $iframe = $('<iframe id="down-file-iframe" />')
  const $form = $('<form target="down-file-iframe" method="' + config.method + '" />')
  $form.attr('action', config.url)
  for (let key in config.data) {
    $form.append('<input type="hidden" name="' + key + '" value="' + config.data[key] + '" />')
  }
  $iframe.append($form)
  $(document.body).append($iframe)
  $form[0].submit()
  $iframe.remove()
}
export default {
  name: 'Home',
  data () {
    return {
      curSysTime: '',
      timeLeft: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
        isEnd: false
      },
      modals: {
        registrationModal: false,
        scheduleMode: false,
        viewMode: false,
        viewModeText: '',
        viewModeIndex: 0,
        downloadScanMode: false
      },
      options: {
        sendMailLoading: false,
        type: 1
      },
      database: {
        id: '',
        info: {},
        list: [],
        myOrder: [],
        myCar: []
      },
      curProgress: 0 // 活动进行到第几阶段
    }
  },
  computed: {
    screenList () {
      const len = this.database.list.length
      // const len = 55
      const num = Math.ceil(len / 10)
      const result = []
      for (let i = 1; i < num + 1; i++) {
        if (i === 1) {
          result.push(`${i}-${i}0`)
        } else {
          result.push(`${i - 1}1-${i}0`)
        }
      }
      return result
    },
    donList () {
      const data = this.database.list
      const won = {
        num: 0,
        weight: 0,
        prize: 0
      }
      for (const item of data) {
        if (parseFloat(item.my_bid_value) === parseFloat(item.won_price)) {
          won.num += 1
          if (item.standard_box_weight) {
            won.weight += parseFloat(item.standard_box_weight)
          } else if (item.d_size) {
            won.weight += parseFloat(item.d_size)
          }
          won.prize += parseFloat(item.my_bid_value)
        }
      }
      return won
    },
    selectList () {
      const data = this.database.list
      const prize = {
        num: 0,
        total: 0
      }
      for (const item of data) {
        if (parseInt(item.auction) !== 0) {
          prize.num += 1
          prize.total += parseFloat(item.bid_value)
        }
      }
      return prize
    },
    orderList () {
      const data = this.database.myOrder
      return data
    },
    carList () {
      const data = this.database.myCar
      for (const item of data) {
        if (typeof item.cart_attribute === 'string') {
          try {
            item.cartAttribute = JSON.parse(item.cart_attribute)
          } catch (e) {
            item.cartAttribute = {}
          }
        } else {
          item.cartAttribute = item.cart_attribute
        }
      }
      return data
    },
    tabBottomStyle () {
      if (this.options.type === 1) {
        return 'background: rgb(178, 164, 211)'
      } else if (this.options.type === 2) {
        return 'background: rgb(110, 193, 174)'
      } else if (this.options.type === 3) {
        return 'background: rgb(216, 237, 244)'
      }
    }
  },
  methods: {
    onSendMail () {
      if (this.curProgress !== 1) {
        return
      }
      this.options.sendMailLoading = true
      let url = '/Auction/Order/BiddingConfirmOrder'
      Core(url, {activity_id: this.database.id}).then(res => {
        if (res.error_code && !res.data) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Message.success('邮件发送成功')
        this.getDetail(() => {
          this.onShowSchedule()
          this.getList()
        })
      }).finally(() => {
        this.options.sendMailLoading = false
      })
    },
    onDown () {
      const data = this.database.list[this.modals.viewModeIndex]
      const param = {}
      param.id = data.id
      param.activity_id = this.database.id
      param.access_token = Core.getAccessToken()
      postDownLoadFile({
        url: 'https://ssma.echao.com/auction/Auction/AuctionActivity/ActivityDiamond',
        data: param,
        method: 'post'
      })
    },
    onGoDetail (item, index) {
      this.$router.push({name: 'ListDetails', query: {activity_id: this.database.id, id: item.id, w: item.standard_box_weight || 0, form: item.form, no: (index +1)}})
    },
    onShowSchedule (type) {
      if (type) {
        this.modals.scheduleMode = true
      }
      const cTime = new Date().getTime() / 1000
      if (cTime < parseInt(this.database.info.place_order_start_time)) {
        // 未开始
        this.curProgress = 0
      } else if (cTime >= parseInt(this.database.info.place_order_start_time) && cTime < parseInt(this.database.info.place_order_end_time)) {
        // 竞拍阶段
        this.curProgress = 1
      } else if (cTime > parseInt(this.database.info.place_order_end_time) && cTime < parseInt(this.database.info.early_morning)) {
        // 等待开盘
        this.curProgress = 2
      } else if (cTime >= parseInt(this.database.info.early_morning)) {
        // 已经结束
        this.curProgress = 3
      }
      // this.curProgress = 1
      // 计算倒计时
      this.runCountTime()
    },
    runCountTime () {
      // 获取当前时间
      let date = new Date()
      let now = date.getTime()
      // 设置截止时间
      let end
      if (this.curProgress === 1) {
        end = parseInt(this.database.info.place_order_end_time) * 1000
      }
      if (this.curProgress === 2) {
        end = parseInt(this.database.info.early_morning) * 1000
      }
      // end = '1583824750000'
      // 时间差
      let leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.timeLeft.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 时
        let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.timeLeft.h = h < 10 ? '0' + h : h
        // 分
        let m = Math.floor(leftTime / 1000 / 60 % 60)
        this.timeLeft.m = m < 10 ? '0' + m : m
        // 秒
        let s = Math.floor(leftTime / 1000 % 60)
        this.timeLeft.s = s < 10 ? '0' + s : s
      } else {
        this.timeLeft.d = 0
        this.timeLeft.h = '00'
        this.timeLeft.m = '00'
        this.timeLeft.s = '00'
      }
      // 等于0的时候不调用
      if (Number(this.timeLeft.d) === 0 && Number(this.timeLeft.h) === 0 && Number(this.timeLeft.m) === 0 && Number(this.timeLeft.s) === 0) {
        if (this.curProgress !== 3) { // 活动还未结束，刷新数据
          location.reload()
          return false
        }
        this.timeLeft.isEnd = true
        return false
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.runCountTime, 1000)
      }
    },
    runSysTime () {
      this.curSysTime = new Date().getTime() / 1000
      setInterval(() => {
        this.curSysTime = new Date().getTime() / 1000
      }, 1000)
    },
    onShowViewModal (type, index) {
      this.modals.viewModeIndex = index
      if (type === 'request') {
        this.modals.viewMode = true
      } else if (type === 'download') {
        this.modals.downloadScanMode = true
      }
    },
    onPrint () {
      window.print()
    },
    // 参与拍卖
    onRegistration () {
      if (this.curProgress > 1) { return this.$Message.error('竞拍阶段已结束！') }
      Core('/Auction/ActivityUser/Signup', {activity_id: this.database.id}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.modals.registrationModal = false
        this.$Message.success('登记成功！')
        this.getDetail(() => {
          this.onShowSchedule()
          this.getList()
        })
      })
    },
    onAuction (index, boo) {
      if (index < 0 || index > this.database.list.length - 1) { return }
      const data = this.database.list[index]
      if (data.bid_value % 1 !== 0) { return }
      const param = {}
      param.activity_id = this.database.id
      param.bid_value = data.bid_value || 0
      param.cart_product_number = boo
      if (parseInt(this.database.info.types) === 0) {
        param.diamond_package_id = data.id
      } else if (parseInt(this.database.info.types) === 1) {
        param.diamond_id = data.id
      }
      console.log(param)
      Core('/Auction/Cart/bidding', {database: param}).then(res => {
        if (res.error_code && !res.data) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Message.success('操作成功！')
        this.getDetail(() => {
          this.onShowSchedule()
          this.getList()
        })
      })
    },
    onPlace (item) {
      const cartId = []
      cartId.push(item.id)
      Core('/Auction/Order/CartCreate', {cart_id: cartId}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Modal.success({
          // title: title,
          content: '订单提交成功'
        })
      })
    },
    onPushCar (item) {
      const database = {
        activity_id: item.id,
        weight: item.weight
      }
      Core('/Auction/Cart/Change', {database}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '加入购物车失败！')
        }
        this.$Message.success('加入购物车成功')
      })
    },
    switchType (type) {
      this.options.type = type
      if (type === 1) {
        this.getList(this.$route.query.type || 1)
      } else if (type === 2) {
        this.getMyCart()
      } else if (type === 3) {
        this.getMyOrder()
      }
    },
    getDetail (callback) {
      const param = {}
      param.activity_id = this.database.id
      Core('/Auction/AuctionActivity/GetOne', param).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        if (res.data) {
          this.database.info = res.data
          callback && callback()
        }
      })
    },
    getMyCart () {
      Core('/Auction/Cart/Listing').then(res => {
        if (res.data && res.data.list) {
          this.database.myCar = res.data.list
        }
      })
    },
    getMyOrder () {
      Core('/Auction/Order/ManagerListing').then(res => {
        if (res.data && res.data.list) {
          this.database.myOrder = res.data.list
        }
      })
    },
    getList () {
      let url = ''
      if (parseInt(this.database.info.types) === 0) { // 钻石包
        url = '/Auction/AuctionActivity/DiamondPackages'
        if (this.curProgress === 3) {
          url = '/Auction/Order/BiddingListing'
        }
      } else if (parseInt(this.database.info.types) === 1) { // 钻石
        url = '/Auction/AuctionActivity/DiamondLists'
        if (this.curProgress === 3) {
          url = '/Auction/Order/BiddingListings'
        }
      }
      if (!url) { return }
      Core(url, {activity_id: this.database.id}).then(res => {
        if (res.data && res.data.list) {
          this.database.list = res.data.list
          for (const item of this.database.list) {
            this.$set(item, 'prize', 0)
            this.$set(item, 'auctionPrize', null)
          }
        }
      })
    }
  },
  filters: {
    unixToDate (unix, format, defValue) {
      if (/\d{13}/.test(unix)) {
        unix = parseInt(unix / 1000, 10)
      }
      let date = moment(/\d{10}/.test(unix) ? moment.unix(unix) : '').format(format || 'YYYY-MM-DD HH:mm:ss')
      return date === 'Invalid date' ? (defValue || '---') : date
    }
  },
  components: {
    MainHeader,
    MainFooter
  },
  mounted () {
    this.database.id = this.$route.query.id
    this.runSysTime()
    this.getDetail(() => {
      this.onShowSchedule()
      this.getList()
    })
    // this.getMyOrder()
    // this.getMyCart()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  >>> .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal{
    top: 0;
  }
  >>> .schedule-modal .ivu-modal-body{padding: 0 5px}
  >>> .schedule-modal .ivu-modal-header{background: #ff9900; border-radius: 6px 6px 0 0;color: #fff}
  .schedule-item{text-align: left; border-bottom: 1px dotted rgb(137, 108, 57); padding: 10px 10px; position: relative}
  .schedule-item:last-child{border: none}
  .schedule-item-name{color: rgb(137, 108, 57); font-size: 16px; font-weight: bold}
  .schedule-item.cur{background: rgb(252, 248, 227)}
  .schedule-success{position: absolute; font-size: 20px;font-weight: bold; right: 10px; top: 30%; color: #378248}
  .content{width: 100%; min-width: 800px; max-width: 1200px; padding: 30px 0; margin: 0 auto}
  .tab{width: 100%; font-size: 16px; display: flex}
  .tab-item{background: rgb(178, 164, 211); width: 230px; line-height: 40px; font-weight: bold; text-align: center; margin-right: 10px;
  border-radius: 5px 5px 0 0; color: #fff;border: 1px solid #7d7d7d; border-bottom: none; cursor: pointer }
  .tab-bottom{width: 100%; height: 30px;}
  .tab-item-type1{background: rgb(178, 164, 211); color: rgb(91, 59, 166)}
  .tab-item-type2{background: rgb(110, 193, 174); color: rgb(45, 109, 82)}
  .tab-item-type3{background: rgb(216, 237, 244); color: rgb(59, 95, 133)}
  .tab-item.active{border-color: rgba(0, 0, 0, 0); color: #fff}
  .tab-total{width: 100%; line-height: 30px; padding: 0 20px; text-align: right}

  .tip{background: rgb(239, 240, 242); border: 1px solid rgb(223, 235, 237); display: flex; color: #787c7e; padding:10px 20px;
  border-radius: 5px; margin: 30px 0}
  .tip-title{width: 260px; font-weight: bold}
  .tip-time{flex: 1}
  .tip-time .tip-time-num{font-weight: bold}

  .icon-search{width: 28px; height: 28px; background: rgb(245, 201, 140); border-radius: 5px; margin-left: 20px }
  .icon-dui{font-size: 20px;}
  .screen{background: rgb(239, 240, 242); border: 1px solid rgb(223, 235, 237);  color: #787c7e; padding:10px 20px;
    border-radius: 5px; margin: 30px 0; overflow: hidden}
  .screen-box{float: right; display: flex; cursor: pointer}
  .screen-value{margin-right: 10px;}
  .screen-icon{color: rgb(118, 147, 164)}
  .btn2s{display: flex; margin-bottom: 30px;}
  .btn2s-item{border: 1px solid #2d8cf0; flex: 1;  line-height: 45px; text-align: center; margin: 0 20px; border-radius: 5px; cursor: pointer}
  .btn2s-item:last-child{margin-right: 0}
  .btn2s-item:first-child{margin-left: 0}
  .btn2s-item .icon-right{width: 13px; height: 13px; margin-top: 10px; margin-right: 10px}

  .registration{width: 100%; border-radius: 5px;border: 1px solid #ffb08f; overflow: hidden}
  .registration-title{background-color: rgb(240, 222, 222); color: rgb(170, 68, 67); font-size: 16px; line-height: 55px; padding-left: 15px; border-bottom: 1px solid #ffb08f}
  .registration-content{line-height: 50px; padding-left: 15px;}
  .registration-btn{background: #eff0f2; line-height: 55px; text-align: right; padding: 0 15px; border-top: 1px solid #cccccc}
  /*.registration-btn-item{float: right;}*/
  table {
    width: 90%;
    background: #ccc;
    margin: 0 auto;
    border-collapse: collapse;/*border-collapse:collapse合并内外边距(去除表格单元格默认的2个像素内外边距*/
  }
  th,td {
    /*height: 25px;*/
    /*line-height: 50px;*/
    padding: 10px 0;
    text-align: center;
    /*border: 1px solid #ccc;*/
  }
  .tab-title{border: 1px solid #ccc;}
  .tab-list{border: 1px solid #ccc; border-top: none}
  th {
    background: #f8f8f9;
    font-weight: normal;
  }
  tr {
    background: #fff;
  }
  /*tr:hover {*/
    /*background: #cc0;*/
  /*}*/
  td a {
    color: #06f;
    text-decoration: none;
  }
  .btns{ overflow: hidden}
  .btns-item{float: right; margin-left: 20px;}

  .icon-zip-box{width: 30px; height: 30px;background: rgb(221, 221, 221); border-radius: 2px; border: 3px solid rgb(241, 241, 241); box-sizing: border-box;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); cursor: pointer; margin: 0 auto}
  .icon-zip-box img{width: 20px; height: 20px; margin-top: 2px;}
</style>



// WEBPACK FOOTER //
// src/components/List.vue